export const calculateProductFinalPrice = (price: number, discount: number): number => {
  if (discount > 0) {
    return Number(price - discount);
  }
  return Number(price);
};
